import { BaseService } from '@/modules/Core/services/BaseService'
import type { IResponseApi } from '@/modules/Core/interfaces'
import type { AxiosResponse } from 'axios'
export class NotificacionEmailService extends BaseService<unknown> {
  constructor () {
    super({
      baseUrl: 'system/notifi/'
    })
  }
  async sendSms (
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http.post<IResponseApi<string>>('/sending-sms', params).catch(this.errorHandle)
  }
  async sendRecordatorioCita (
    correo: string,
    params: Record<string, unknown> | Record<string, unknown>[]
  ): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http.post<IResponseApi<string>>('/send-reminder-scheduling?correo='+correo, params).catch(this.errorHandle)
  }
  async sendHistory(
    correo: string,
    files: { [key: string]: File },
    params?: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<string>>> {
    const formData = new FormData()

    // Agregar archivos al FormData
    Object.entries(files).forEach(([key, file]) => {
      formData.append(key, file)
    })

    // Agregar parámetros adicionales si existen
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        formData.append(key, String(value))
      })
    }

    return this.http.post<IResponseApi<string>>(
      `send-email-history?correo=${correo}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    ).catch(this.errorHandle)
  }
  async postUserCreated (params: Record<string, unknown>): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http.post<IResponseApi<string>>('/user-created', params).catch(this.errorHandle)
  }
}
